/* TKA: caption column, turning pieces, header tone over full-bleed images. */
(() => {
  if (window.__tka) return;
  window.__tka = true;
  const still = window.matchMedia('(prefers-reduced-motion: reduce)');

  const turn = (plate, i) => {
    const imgs = [...plate.querySelectorAll('.tka__im img')];
    const vws = [...plate.querySelectorAll('.tka__vw b')];
    if (imgs.length < 2) return;
    const k = i % imgs.length;
    imgs.forEach((im, n) => { im.style.opacity = n === k ? 1 : 0; });
    vws.forEach((b, n) => b.classList.toggle('on', n === k));
  };

  const initCat = (cat) => {
    if (cat.dataset.tkaReady) return;
    cat.dataset.tkaReady = '1';
    const spec = cat.querySelector('.tka__spec--live');
    const lines = spec ? [...spec.children] : [];
    let timer = null;
    const set = (plate) => {
      clearInterval(timer);
      cat.querySelectorAll('.tka__plate').forEach((p) => { if (p !== plate) turn(p, 0); });
      if (lines.length) {
        lines[0].textContent = plate ? plate.dataset.n || '' : ' ';
        lines[1].textContent = plate ? plate.dataset.d || '' : ' ';
        lines[2].textContent = plate ? plate.dataset.p || '' : ' ';
      }
      if (plate && !still.matches) {
        let i = 0;
        turn(plate, ++i);
        timer = setInterval(() => turn(plate, ++i), 900);
      }
    };
    const touch = window.matchMedia('(hover: none)');
    cat.querySelectorAll('.tka__plate').forEach((p) => {
      const n = p.querySelectorAll('.tka__im img').length;
      if (n > 1) {
        let cur = 0;
        const go = (e, k) => {
          e.preventDefault();
          e.stopPropagation();
          clearInterval(timer);
          cur = k % n;
          turn(p, cur);
        };
        p.querySelectorAll('.tka__vw b').forEach((b, k) => b.addEventListener('click', (e) => go(e, k)));
        p.querySelector('.tka__im').addEventListener('click', (e) => { if (touch.matches) go(e, cur + 1); });
      }
      p.addEventListener('mouseenter', () => { if (!touch.matches) set(p); });
      p.addEventListener('focus', () => { if (!touch.matches) set(p); });
      p.addEventListener('mouseleave', () => { if (!touch.matches) set(null); });
      p.addEventListener('blur', () => { if (!touch.matches) set(null); });
    });
  };

  let lastY = 0;
  const hd = () => document.querySelector('[data-tka-header]');
  const tone = () => {
    const h = hd();
    if (!h) return;
    const pw = document.querySelector('.page-wrapper');
    const y = Math.max(window.scrollY, pw ? pw.scrollTop : 0);
    h.classList.toggle('is-scrolled', y > 8);
    const small = window.matchMedia('(max-width: 900px)').matches;
    const dy = y - lastY;
    if (!small || y < 160) h.classList.remove('is-hidden');
    else if (dy > 6) h.classList.add('is-hidden');
    else if (dy < -6) h.classList.remove('is-hidden');
    if (Math.abs(dy) > 6) lastY = y;
    if (!h.hasAttribute('data-overlay')) return;
    const bleed = document.querySelector('.tka__bleed');
    const r = bleed && bleed.getBoundingClientRect();
    h.classList.toggle('is-on-image', !!(r && r.top <= 0 && r.bottom > 60));
  };

  const init = (root = document) => {
    root.querySelectorAll('[data-tka-cat]').forEach(initCat);
    tone();
  };

  document.addEventListener('DOMContentLoaded', () => init());
  if (document.readyState !== 'loading') init();
  document.addEventListener('scroll', tone, { passive: true, capture: true });
  document.addEventListener('shopify:section:load', (e) => init(e.target));
})();
